let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7MPP6")).then(() => parcelRequire('8icpB'));